import { render, staticRenderFns } from "./serviceTimeCrit.vue?vue&type=template&id=2d107d5b"
import script from "./serviceTimeCrit.vue?vue&type=script&lang=js"
export * from "./serviceTimeCrit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports